import * as React from 'react'

import { Box, Line, Title } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const HubsSectionTitle = () => {
  return (
    <Box paddingTop="s80" paddingBottom="s64" alignItems="center" gap="s12">
      <Title
        title={i18n.t('pricing_plans.personalised_hub.separator.title')}
        description={i18n.t('pricing_plans.personalised_hub.separator.description')}
        illustration="window-star"
        illustrationColor="grey600"
        variant={500}
        centered
      />
      <Line />
    </Box>
  )
}

export default HubsSectionTitle
